import dayjs, { Dayjs } from "dayjs";

export type T_DateRange = { label: string; startDate: string; endDate: string };
export type T_DateRangeOptional = { label: string; startDate: string | undefined; endDate: string | undefined };

function toStartDate(date: Dayjs, unit: dayjs.OpUnitType) {
  return date.startOf(unit).toISOString();
}
function toEndDate(date: Dayjs, unit: dayjs.OpUnitType) {
  return date.endOf(unit).toISOString();
}

export function dateRanges() {
  const currDate = dayjs();
  const yesterday = currDate.subtract(1, "day");
  const day30Ago = currDate.subtract(30, "day");
  const day90Ago = currDate.subtract(90, "day");
  const ranges: T_DateRange[] = [
    { label: "Today", startDate: toStartDate(currDate, "date"), endDate: toEndDate(currDate, "date") },
    { label: "Yesterday", startDate: toStartDate(yesterday, "date"), endDate: toEndDate(yesterday, "date") },
    { label: "This Week", startDate: toStartDate(currDate, "week"), endDate: toEndDate(currDate, "week") },
    { label: "This Month", startDate: toStartDate(currDate, "month"), endDate: toEndDate(currDate, "month") },
    { label: "This Year", startDate: toStartDate(currDate, "year"), endDate: toEndDate(currDate, "year") },
    { label: "Last 30 days", startDate: toStartDate(day30Ago, "date"), endDate: toEndDate(currDate, "date") },
    { label: "Last 90 days", startDate: toStartDate(day90Ago, "date"), endDate: toEndDate(currDate, "date") },
  ];
  return ranges;
}

export function getSelectedDateRange(start: string | undefined, end: string | undefined): T_DateRangeOptional {
  if (!start || !end) return { label: "Custom", startDate: start, endDate: end };
  const foundDateRange = dateRanges().find((el) => el.startDate === start && el.endDate === end);
  if (foundDateRange)
    return { label: foundDateRange.label, startDate: foundDateRange.startDate, endDate: foundDateRange.endDate };
  else return { label: "Custom", startDate: start, endDate: end };
}

export const initialDateRange = dateRanges()[0];
